import React from "react";
import { Typography } from "@mui/material";
import { ComponentExample } from "components/examples";

const FormValidation = () => (
  <React.Fragment>
    <Typography variant="h5" gutterBottom>
      Form Validation
    </Typography>
    <ComponentExample
      name="Standard validation"
      description="Most form fields have built-in validation for common use cases. Error messages can be customised using the corresponding 'error' prop."
      import={import("examples/Forms/FormValidation/StandardValidationExample")}
      rawImport={import(
        "examples/Forms/FormValidation/StandardValidationExample?raw"
      )}
    />
    <ComponentExample
      name="Custom validation"
      description="Custom error messages can be added to fields using the customValidator prop."
      import={import("examples/Forms/FormValidation/CustomValidationExample")}
      rawImport={import(
        "examples/Forms/FormValidation/CustomValidationExample?raw"
      )}
    />
    <ComponentExample
      name="Advanced validation"
      description="For advanced validation such as validating multiple fields, use the CustomErrors component."
      import={import("examples/Forms/FormValidation/AdvancedValidationExample")}
      rawImport={import(
        "examples/Forms/FormValidation/AdvancedValidationExample?raw"
      )}
    />
    <ComponentExample
      name="Async validation"
      description="For async field validation using the CustomErrors component."
      import={import("examples/Forms/FormValidation/AsyncValidationExample")}
      rawImport={import(
        "examples/Forms/FormValidation/AsyncValidationExample?raw"
      )}
    />
  </React.Fragment>
);

export default FormValidation;
